export interface PaygPricingBounds {
    minAmountCents: number;
    maxAmountCents: number;
    stepAmountCents: number;
}

export function normalizePaygAmountCents(
    value: string | number | null | undefined,
    pricing: PaygPricingBounds | null | undefined,
): number | null {
    if (!pricing) return null;

    const { minAmountCents, maxAmountCents, stepAmountCents } = pricing;
    if (
        !Number.isSafeInteger(minAmountCents) ||
        !Number.isSafeInteger(maxAmountCents) ||
        !Number.isSafeInteger(stepAmountCents) ||
        minAmountCents <= 0 ||
        maxAmountCents < minAmountCents ||
        stepAmountCents <= 0
    ) {
        return null;
    }

    const parsed = typeof value === 'number' ? value : Number(value);
    if (
        !Number.isSafeInteger(parsed) ||
        parsed < minAmountCents ||
        parsed > maxAmountCents ||
        (parsed - minAmountCents) % stepAmountCents !== 0
    ) {
        return minAmountCents;
    }

    return parsed;
}
